<div class="row col-12 p-0 m-0">
  <div class="col-12 p-0">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div class="breadcrumbs-section">
        <span class="prev-page"><a routerLink="/overview">Home</a></span>
        <img class="separator pr-2 pl-2" src="../../../assets/images/seperator.png">
        <span class="prev-page  "><a routerLink="/members/members-list">Members</a></span>
        <img class="separator pr-2 pl-2" src="../../../assets/images/seperator.png">
        <span class="curr-page breadcrumbs-section-font">Email Member(s)</span>
      </div>

      <div class="d-flex justify-content-between meetings-layout">
        <div class="meetings ">Email Member(s)
        </div>

      </div>
      <div class="email-box">
        <div class="mt-4  d-flex  row borders m-0 p-0 ">
          <div class="col-1 margin-auto p-0">
            From:
          </div>
          <div class="col-11 margin-auto">
            <div class="from-rectangle ">
              <span class="from-id ">{{memberDetail?.adminEmailId}}</span>
            </div>
          </div>

        </div>

        <div class=" d-flex  row to-borders m-0 p-0">
          <div class="col-1" style="padding-top: 15px;padding-bottom: 15px;padding-left: 0;">
            To:
          </div>

          <div class="d-flex row mt-2 ml-2">
            <div class="d-flex">
              <div class="col-3-to-ids pb-2">
                <div class="d-flex">
                  <div class="rectangle-select">
                    <span class="to-id mt-2 ml-3 mr-3">{{toId}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row d-flex to-borders  m-0 p-0">
          <div class="col-1" style="padding-top: 15px;padding-left: 0;">
            Bcc:
          </div>
          <div *ngIf="!show" class="d-flex col-11 to-contents ">
            <div *ngFor="let email of emailList | slice:0: constraint ;let index=index" class="email-tile">
              <div class="d-flex tile" *ngIf="index<3">
                <div class="email">
                  <span>{{maskEmail(email)}}</span>
                </div>
                <div class="remove-email" *ngIf="emailList.length>1">
                  <!-- <div class="remove-email" > -->
                  <img src="/assets/images/cross-mark.png" (click)="removeItems(email)">
                </div>
              </div>
            </div>

            <div class="d-flex more-email-tile" *ngIf="emailList.length > 3 && !show" (click)="toggleShow()">
              <div class="email">
                <span>+ {{emailList.length-3}} members</span>
              </div>
              <div class="remove-email">
                <img src="/assets/images/Path.png">
              </div>
            </div>

          </div>
          <div class="d-flex col-11 to-contents " *ngIf="show">
            <div class="row">
              <div class="more-tile" *ngFor="let email of emailList ;let index=index">
                <div class="d-flex tile email-tile">
                  <div class="email">
                    <span>{{email}}</span>
                  </div>
                  <div class="remove-email">
                    <img src="/assets/images/cross-mark.png" (click)="removeItems(email)">
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
        <div class="subject">
          <div class="row to-borders d-flex justify-content-between ml-0 mr-0 mt-1 mb-1 p-0 ">
            <div class=" col-1  margin-auto p-0">
              Subject:
            </div>
            <div class="col-11 margin-auto">
              <input type="text" class="pl-3 input-border-subject" [(ngModel)]="subject">
            </div>

          </div>

        </div>
        <div class="email-layout ">
          <textarea rows="4" class="pl-3 input-border pt-3 layout-height c2 scroll-position"
            [(ngModel)]="body"></textarea>
          <!-- <input type="text" class="pl-3 input-border pt-3 layout-height c2 scroll-position"   > -->
        </div>
      </div>

      <div class="d-flex justify-content-between meetings-layout button-footer">
        <div class="sub-label pt-4">
          <button class="cancel-button pr-5">
            <span class="cancel" (click)="cancel()">Back to Member Listing</span>
          </button>
        </div>
        <div class="pt-3">
          <button class="cancel-button pr-5" (click)="cancel()">
            <span class="cancel">Cancel</span>
          </button>
          <button class="add-button" (click)="sendemail()" [disabled]="emailList && emailList.length == 0">
            <span class="add">Send Email</span>
          </button>
        </div>

      </div>
    </div>

  </div>
</div>